import Nav from '../Components/Nav'
import Shop from '../Components/Shop'
const Home = () => {
  return (
    <>
      <Shop/>
    </>
  )
}

export default Home